// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5a2e6cc5","453":"f3ed9788","667":"9c0445fe","977":"6dc90e40"}[chunkId] + ".chunk.js";
};